import { Grid, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import LinkI18N from './LinkI18N';
import { useBrand } from '../../hooks/useBrand';

const useStyles = makeStyles<Theme>((theme) => ({
    root: {
        color: theme.palette.text.background,
        justifyContent: 'center',
        marginBottom: 16,
        marginTop: 16,
        maxWidth: 452,
        margin: '0 auto',
        textAlign: 'center',
    },
}));

function LegalLinks() {
    const brandInfo = useBrand();
    const classes = useStyles();

    return (
        <Grid container className={classes.root}>
            <LinkI18N href={brandInfo.links.privacyPolicy}>Privacy Policy</LinkI18N>
            <LinkI18N href={brandInfo.links.faq}>FAQs</LinkI18N>
            <LinkI18N href={brandInfo.links.termsAndConditions}>Terms and Conditions</LinkI18N>
            <LinkI18N href={brandInfo.links.nonDiscrimination}>Non-discrimination</LinkI18N>
        </Grid>
    );
}

export default LegalLinks;
